import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { OpportunityActionButton } from '../../new-primary-dashboard/new-primary-dashboard.models';
import { FlyoutOpeningData } from '../flyout-models';
import { FlyoutService } from '../flyout.service';

/**
 * The detail behind one dashboard recommendation: what it means, and the tactics that answer it.
 * Content comes in through `flyoutOpeningData` so this stays a renderer, and the recommendations
 * engine can supply the same shape later without touching it.
 */
@Component({
  selector: 'app-flyout-recommendation',
  templateUrl: './flyout-recommendation.component.html',
  styleUrls: ['./flyout-recommendation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FlyoutRecommendationComponent {
  private readonly flyoutService = inject(FlyoutService);
  private readonly router = inject(Router);

  @Input() flyoutOpeningData: FlyoutOpeningData;

  protected closeFlyout(): void {
    this.flyoutService.close();
  }

  /** A button with no route is one whose destination is still being decided; it renders disabled. */
  protected start(button: OpportunityActionButton): void {
    if (!button.route) {
      return;
    }
    // Close first: leaving the panel open over the page the user just asked for reads as a bug.
    this.flyoutService.close();
    void this.router.navigate([...button.route], button.queryParams ? { queryParams: button.queryParams } : {});
  }
}
